import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [scorms, setScorms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedScorm, setSelectedScorm] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenUrl = params.get('app_token');

    if (tokenUrl) {
      localStorage.setItem('oage_token', tokenUrl);
      window.history.replaceState({}, document.title, "/");
    }

    const token = localStorage.getItem('oage_token');
    
    if (!token) {
      setError("Acceso denegado. Entra desde oposicionesage.com");
      setLoading(false);
    } else {
      fetchData(token);
    }
  }, []);

  const fetchData = async (token) => {
    try {
      const response = await fetch('https://oposicionesage.es/wp-json/oage/v2/scorms', {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.success) {
        setScorms(data.scorms || []);
      } else {
        setError("Sesión expirada o sin permisos.");
      }
    } catch (err) {
      setError("Error de conexión con OAGE.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="container"><div className="card">Cargando...</div></div>;
  if (error) return <div className="container"><div className="card" style={{borderLeft:'4px solid red'}}>{error}</div></div>;

  return (
    <div className="container">
      <div className="list-header">
        <div className="list-title">
          <h2>Mis Cursos SCORM</h2>
          <span className="count-pill">{scorms.length}</span>
        </div>
      </div>
      <hr />
      {!selectedScorm ? (
        <div className="table-card card">
          <table className="table-pro">
            <tbody>
              {scorms.map(s => (
                <tr key={s.id} className="row-click" onClick={() => setSelectedScorm(s)}>
                  <td className="title-cell">{s.title}</td>
                  <td style={{textAlign:'right'}}><button className="btn-secondary">Abrir</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="modal-overlay">
          <div className="modal" style={{width:'98vw', height:'95vh'}}>
            <div className="modal-header">
              <div className="modal-title">{selectedScorm.title}</div>
              <button className="icon-btn" onClick={() => setSelectedScorm(null)}>Cerrar</button>
            </div>
            <div className="modal-body" style={{padding:0}}>
              <iframe src={selectedScorm.url} style={{width:'100%', height:'100%', border:'none'}} title="scorm" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
